var _module = require('../../components/module.js');
var config = require('config');
var _ = require('lodash');

_module.service('$favorites', [
    '$log',
    '$http',
    '$filter',
    '$window',
    '$state',
    'localStorageService',

    function favoritesService($log, $http, $filter, $window, $state, localStorageService) {
        return {

            getAll: function (id) {
                return $http.get('/v1/favorite/' + id)
                    .then(function (response) {
                        /**
                         * We need to make sure all the results have a unique listing_id
                         * or else we will get issues with ng-repeat.
                         */
                        return _.uniqBy(response.data.data, 'listing_id');
                    });
            },

            favorite: function (postData) {
                if(postData && postData.listing) {
                    var listingData = JSON.parse(JSON.stringify(postData.listing));

                    var excludeProperties = [
                        'detailViewParams',
                        'lat',
                        'lon',
                        'realtor_company',
                        'realtor_name'
                    ];

                    angular.forEach(excludeProperties, function (key, i) {
                        delete this[key];
                    }, listingData);

                    postData.listing = listingData;

                    return $http.post('/v1/favorite', postData)
                        .then(function (response) {
                            return response.data;
                        })
                        .catch(function (err) {
                            $log.error('Favorite Error: ', postData, err);
                        });
                }else {
                    $log.debug('Favorite Error: Invalid postData or postData.listing is missing.', postData);
                }
            },

            unfavorite: function (id) {
                return $http.delete('/v1/favorite/' + id)
                    .then(function (response) {
                        return response.data;
                    })
                    .catch(function (err) {
                        $log.error('Unfavorite Error: ', id, err);
                    });
            },

            getPaginated: function (favorites, page) {
                page = page || 1;
                var per_page = 50;
                var offset = (page - 1) * per_page;
                var paginatedItems = favorites.slice(offset, offset + per_page);
                var _this = this;

                return {
                    offset_start: offset + 1,
                    offset_end: offset + paginatedItems.length,
                    page: page,
                    per_page: per_page,
                    total: favorites.length,
                    total_pages: Math.ceil(favorites.length / per_page),
                    data: paginatedItems
                };

            }
        };
    }
]);
